module.exports = __webpack_public_path__ + "static/media/step1@1x.d311a8b7.mov";